(() => {
  const SHADOW_CSS = `
    :host {
      width: 100% !important;
      max-width: 100% !important;
      margin-left: auto !important;
      margin-right: auto !important;
      display: block !important;
      box-sizing: border-box !important;
      overflow: visible !important;
      --form-background-color: transparent !important;
      --form-text-color: #ffffff !important;
      --form-label-color: #ffffff !important;
      --form-placeholder-color: rgba(255, 255, 255, 0.65) !important;
      --color-foreground: #ffffff !important;
      --color-text: #ffffff !important;
      --container-background-color: transparent !important;
      --buttons-background-color: transparent !important;
      --buttons-text-color: #ffffff !important;
    }

    :host, form, [data-testid="form"] {
      background: transparent !important;
      color: #ffffff !important;
    }

    [data-testid="form"] {
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      box-sizing: border-box !important;
      overflow: visible !important;
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) !important;
      gap: 0 !important;
    }

    [class*="formContainer"],
    [class*="formFieldset"],
    [class*="inline"],
    [class*="gridItem"],
    [class*="gridItemContent"],
    [class*="container"] {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
      overflow: visible !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    [data-testid="form"] > * {
      margin-bottom: 20px !important;
    }

    [data-testid="form"] > div:has(shop-lead-capture):not(:has([class*="formFieldContainer"])) {
      margin-bottom: 0 !important;
    }

    [data-testid="form"] > [class*="formFieldContainer"],
    [data-testid="form"] > [data-testid="date-birthday"],
    [data-testid="form"] > div:has([class*="formFieldContainer"]),
    [data-testid="form"] > div:has(textarea),
    [data-testid="form"] > div:has(input[type="file"]) {
      margin-bottom: 20px !important;
      width: 100% !important;
      grid-column: 1 / -1 !important;
    }

    [class*="formFieldContainer"] {
      display: flex !important;
      flex-direction: column !important;
      align-items: stretch !important;
      margin-bottom: 20px !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      background: transparent !important;
      position: relative !important;
      box-sizing: border-box !important;
      overflow: visible !important;
    }

    [class*="formInputFieldLabel"],
    label[id^="label-"] {
      position: static !important;
      transform: none !important;
      top: auto !important;
      left: auto !important;
      right: auto !important;
      order: -1 !important;
      display: block !important;
      margin: 0 0 0.5rem 0 !important;
      padding: 0 !important;
      min-height: 0 !important;
      height: auto !important;
      width: auto !important;
      z-index: auto !important;
      background: transparent !important;
      background-color: transparent !important;
      color: #ffffff !important;
      -webkit-text-fill-color: #ffffff !important;
      font-size: 0.95rem !important;
      font-weight: 700 !important;
      line-height: 1.4 !important;
      pointer-events: auto !important;
      box-shadow: none !important;
      border: none !important;
      text-shadow: none !important;
    }

    label,
    legend,
    [data-testid="label"],
    [class*="birthdayText"],
    p[class*="_label_"],
    [class*="checkboxLegend"],
    [class*="formFileInput"] p[class*="textBody"],
    [class*="formFileInput"] > p:not([class*="formFileInputButton"]):not(.sg-sw-file-status):not(.sg-sw-file-help) {
      color: #ffffff !important;
      -webkit-text-fill-color: #ffffff !important;
      font-size: 0.95rem !important;
      font-weight: 700 !important;
      text-shadow: none !important;
    }

    input:not([type="checkbox"]):not([type="radio"]):not([type="file"]),
    textarea,
    select,
    input[class*="formInputField"],
    [class*="formPhoneInputField"],
    .sg-sw-native-date {
      color: #ffffff !important;
      background-color: rgba(255, 255, 255, 0.08) !important;
      border: none !important;
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.45) !important;
      border-radius: 4px !important;
      min-height: 2.75rem !important;
      padding: 9px 12px 7px !important;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box !important;
    }

    .sg-sw-native-date {
      -webkit-appearance: none;
      appearance: none;
      color-scheme: dark;
      margin-top: 0;
      height: 2.75rem !important;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      display: flex !important;
      align-items: center !important;
      line-height: normal !important;
      position: relative !important;
      cursor: pointer !important;
    }

    .sg-sw-native-date::-webkit-date-and-time-value {
      text-align: left;
      color: #ffffff;
      margin: 0 !important;
      line-height: 2.75rem !important;
      height: 2.75rem !important;
    }

    input[type="date"]::-webkit-datetime-edit,
    input[type="date"]::-webkit-datetime-edit-fields-wrapper,
    input[type="date"]::-webkit-datetime-edit-text,
    input[type="date"]::-webkit-datetime-edit-month-field,
    input[type="date"]::-webkit-datetime-edit-day-field,
    input[type="date"]::-webkit-datetime-edit-year-field,
    .sg-sw-native-date::-webkit-datetime-edit,
    .sg-sw-native-date::-webkit-datetime-edit-fields-wrapper,
    .sg-sw-native-date::-webkit-datetime-edit-text,
    .sg-sw-native-date::-webkit-datetime-edit-month-field,
    .sg-sw-native-date::-webkit-datetime-edit-day-field,
    .sg-sw-native-date::-webkit-datetime-edit-year-field {
      color: #ffffff !important;
      background: transparent !important;
    }

    input[type="date"]::-webkit-calendar-picker-indicator,
    .sg-sw-native-date::-webkit-calendar-picker-indicator {
      filter: brightness(0) invert(1) !important;
      opacity: 1 !important;
      cursor: pointer;
    }

    /* The icon is a flex child of the input's internal shadow row, so auto
       margins can't reach it. Pin it instead, 11px in from the right edge to
       match the inset of the select dropdown carets. */
    .sg-sw-native-date::-webkit-calendar-picker-indicator {
      position: absolute !important;
      top: 50% !important;
      right: 11px !important;
      transform: translateY(-50%) !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    textarea {
      min-height: 6rem !important;
      padding: 0.65rem 0.75rem !important;
    }

    textarea[name="custom#speedgrip_representative_email"] {
      min-height: 2.75rem !important;
      height: 2.75rem !important;
      padding: 9px 12px 7px !important;
      resize: none !important;
      overflow: hidden !important;
      white-space: nowrap !important;
    }

    input::placeholder,
    textarea::placeholder {
      color: rgba(255, 255, 255, 0.65) !important;
      opacity: 1 !important;
    }

    input[type="checkbox"],
    input[type="radio"] {
      -webkit-appearance: none !important;
      appearance: none !important;
      width: 1.15rem !important;
      height: 1.15rem !important;
      min-width: 1.15rem !important;
      min-height: 1.15rem !important;
      padding: 0 !important;
      flex: 0 0 auto !important;
      box-sizing: border-box !important;
      background-color: #000000 !important;
      border: 1px solid #ffffff !important;
      box-shadow: none !important;
      background-repeat: no-repeat !important;
      background-position: center !important;
      background-size: 0.8rem 0.8rem !important;
      cursor: pointer !important;
      accent-color: #000000 !important;
    }

    input[type="checkbox"] {
      border-radius: 3px !important;
    }

    input[type="radio"] {
      border-radius: 50% !important;
    }

    input[type="checkbox"]:checked {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M4.5 10.5l4 4L15.5 6.5' fill='none' stroke='%23ffffff' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
    }

    input[type="radio"]:checked {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Ccircle cx='10' cy='10' r='4.5' fill='%23ffffff'/%3E%3C/svg%3E") !important;
    }

    button[type="submit"],
    [data-testid="btn-form-submit"],
    [class*="formSubmitButton"] {
      color: #ffffff !important;
      background: transparent !important;
      border: 2px solid #ffffff !important;
      border-radius: 4px !important;
      padding: 0.65rem 1.25rem !important;
      /* Custom properties cross the shadow boundary, so this tracks the sitewide
         button height from styles.css. */
      min-height: var(--sg-button-height, 3.45rem) !important;
      box-sizing: border-box !important;
      font-size: 1rem !important;
      line-height: 1.5 !important;
      font-weight: 600 !important;
      text-transform: uppercase !important;
      letter-spacing: 0.04em !important;
      margin-top: 0.5rem !important;
      margin-bottom: 20px !important;
      width: auto !important;
      min-width: 0 !important;
      max-width: none !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      justify-self: start !important;
      align-self: start !important;
      grid-column: 1 / -1 !important;
    }

    button[type="submit"]:hover,
    [data-testid="btn-form-submit"]:hover,
    [class*="formSubmitButton"]:hover {
      background: rgba(255, 255, 255, 0.12) !important;
      color: #ffffff !important;
      border-color: #ffffff !important;
    }

    button[type="button"]:not([class*="formFileInputField"]):not([class*="selectToggle"]):not([class*="formFileInputRemove"]):not([class*="formFileInputCancel"]):not(.sg-sw-file-remove) {
      color: #ffffff !important;
      background-color: rgba(255, 255, 255, 0.08) !important;
      border: none !important;
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.45) !important;
      border-radius: 4px !important;
    }

    [class*="formPhoneInputContainer"] {
      display: grid !important;
      grid-template-columns: auto minmax(0, 1fr) !important;
      grid-template-rows: auto auto !important;
      column-gap: 0.5rem !important;
      row-gap: 0.5rem !important;
      align-items: stretch !important;
      width: 100% !important;
      margin-bottom: 20px !important;
    }

    [class*="formPhoneInputContainer"] [class*="formFieldContainer"] {
      display: contents !important;
      margin-bottom: 0 !important;
    }

    [class*="formPhoneInputContainer"] [class*="formFieldContainer"] label,
    [class*="formPhoneInputContainer"] label[id^="label-phone"] {
      grid-column: 1 / -1 !important;
      grid-row: 1 !important;
      margin: 0 0 0.5rem 0 !important;
      text-align: left !important;
      width: 100% !important;
    }

    [class*="formPhoneInputContainer"] .phone-country-selector {
      grid-column: 1 !important;
      grid-row: 2 !important;
      align-self: stretch !important;
      margin: 0 !important;
    }

    [class*="formPhoneInputContainer"] input[type="tel"],
    [class*="formPhoneInputField"] {
      grid-column: 2 !important;
      grid-row: 2 !important;
      width: 100% !important;
      margin: 0 !important;
    }

    .phone-country-selector,
    [class*="selectContainer"] {
      height: 100% !important;
      display: flex !important;
      align-items: stretch !important;
    }

    [class*="selectToggle"] {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 0.35rem !important;
      min-height: 2.75rem !important;
      height: 100% !important;
      padding: 0 0.65rem !important;
      min-width: 5.5rem !important;
      box-sizing: border-box !important;
      color: #ffffff !important;
      background-color: rgba(255, 255, 255, 0.08) !important;
      border: 1px solid rgba(255, 255, 255, 0.45) !important;
      box-shadow: none !important;
      border-radius: 4px !important;
      outline: none !important;
    }

    [class*="selectToggle"]:hover,
    [class*="selectToggle"]:focus,
    [class*="selectToggle"][aria-expanded="true"] {
      color: #ffffff !important;
      background-color: rgba(255, 255, 255, 0.08) !important;
      border: 1px solid rgba(255, 255, 255, 0.45) !important;
      box-shadow: none !important;
      outline: none !important;
    }

    [class*="selectToggleText"],
    [class*="selectToggle"] [class*="selectToggleText"],
    [class*="selectToggle"] [class*="arrowDownIcon"] {
      display: inline-flex !important;
      align-items: center !important;
      background: transparent !important;
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
      min-height: 0 !important;
      width: auto !important;
      max-width: none !important;
      flex: 0 0 auto !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    [class*="selectContainer"]:has(p[class*="_label_"]) [class*="selectToggle"] [class*="selectToggleText"] {
      flex: 1 1 auto !important;
      width: auto !important;
      justify-content: flex-start !important;
    }

    [class*="arrowDownIcon"] svg,
    [class*="arrowDownIcon"] svg path,
    [class*="selectToggle"] svg path {
      fill: #ffffff !important;
    }

    [class*="flagIcon"] {
      display: block !important;
      width: 1.25rem !important;
      height: auto !important;
    }

    [class*="dropdownContainer"],
    #country-selector-dropdown,
    [class*="optionList"] {
      background-color: #1a6421 !important;
      color: #ffffff !important;
      border: 1px solid rgba(255, 255, 255, 0.45) !important;
      border-radius: 4px !important;
      box-shadow: none !important;
    }

    [class*="optionListItem"] [role="option"],
    [class*="optionListItem"] div[tabindex] {
      color: #ffffff !important;
      background: transparent !important;
      padding: 0.5rem 0.75rem !important;
      cursor: pointer !important;
    }

    [class*="optionListItem"] [role="option"]:hover,
    [class*="optionListItem"] div[tabindex]:hover,
    [class*="optionListItem"] [aria-selected="true"] {
      background-color: rgba(255, 255, 255, 0.12) !important;
      color: #ffffff !important;
    }

    .sg-sw-state-select {
      cursor: pointer !important;
      appearance: none !important;
      -webkit-appearance: none !important;
      color: #ffffff !important;
      background-color: rgba(255, 255, 255, 0.08) !important;
      border: none !important;
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.45) !important;
      border-radius: 4px !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 24'%3E%3Cpath d='M4 9.5L8 5.5l4 4' fill='none' stroke='%23ffffff' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M4 14.5l4 4 4-4' fill='none' stroke='%23ffffff' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
      background-repeat: no-repeat !important;
      background-position: right 12px center !important;
      background-size: 1rem 1.5rem !important;
      padding-right: 2.5rem !important;
    }

    .sg-sw-state-select option {
      color: #202020 !important;
      background: #ffffff !important;
    }

    [class*="birthdayText"] {
      font-weight: 700 !important;
      color: #ffffff !important;
      font-size: 0.95rem !important;
      margin: 0 0 0.5rem 0 !important;
      text-transform: none !important;
      letter-spacing: normal !important;
      background: transparent !important;
      box-shadow: none !important;
      display: block !important;
      width: 100% !important;
    }

    [class*="selectContainer"]:has(p[class*="_label_"]) {
      display: flex !important;
      flex-direction: column !important;
      align-items: stretch !important;
      width: 100% !important;
      margin-bottom: 20px !important;
    }

    [class*="selectContainer"]:has(p[class*="_label_"]) p[class*="_label_"] {
      color: #ffffff !important;
      -webkit-text-fill-color: #ffffff !important;
      font-weight: 700 !important;
      text-transform: none !important;
      letter-spacing: normal !important;
      margin: 0 0 0.5rem 0 !important;
      width: 100% !important;
      background: transparent !important;
      box-shadow: none !important;
      min-height: 0 !important;
      padding: 0 !important;
      border: none !important;
      text-shadow: none !important;
    }

    [class*="selectContainer"]:has(p[class*="_label_"]) [class*="selectToggle"] {
      width: 100% !important;
      justify-content: space-between !important;
    }

    [class*="checkboxLegend"] {
      font-weight: 700 !important;
      text-transform: none !important;
      color: #ffffff !important;
      font-size: 0.95rem !important;
      margin: 0 0 0.75rem 0 !important;
      padding: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      float: none !important;
      display: block !important;
      width: 100% !important;
    }

    [class*="checkboxFieldSet"] {
      margin-bottom: 20px !important;
      border: none !important;
      padding: 0 !important;
      min-width: 0 !important;
    }

    [class*="formFileInput"] p[class*="textBody"],
    [class*="formFileInput"] > p:not([class*="formFileInputButton"]):not(.sg-sw-file-status):not(.sg-sw-file-help) {
      font-weight: 700 !important;
      color: #ffffff !important;
      font-size: 0.95rem !important;
      margin: 0 0 0.5rem 0 !important;
      text-transform: none !important;
      letter-spacing: normal !important;
      background: transparent !important;
      box-shadow: none !important;
      padding: 0 !important;
      border: none !important;
      min-height: 0 !important;
    }

    [class*="formFileInput"] {
      margin-bottom: 20px !important;
      width: 100% !important;
    }

    [class*="formFileInputField"] {
      display: flex !important;
      flex-direction: row !important;
      align-items: center !important;
      justify-content: flex-start !important;
      position: relative !important;
      width: 100% !important;
      min-height: 2.75rem !important;
      height: auto !important;
      padding: 0.65rem !important;
      gap: 0.75rem !important;
      color: #ffffff !important;
      background-color: rgba(255, 255, 255, 0.08) !important;
      border: none !important;
      box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.45) !important;
      border-radius: 0 !important;
      cursor: pointer !important;
      font-weight: 700 !important;
      box-sizing: border-box !important;
      text-align: left !important;
      overflow: visible !important;
    }

    [class*="formFileInputField"] > * {
      align-self: center !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

    [class*="formFileInputLabel"] {
      position: absolute !important;
      inset: 0 !important;
      width: 100% !important;
      height: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      z-index: 5 !important;
      cursor: pointer !important;
      display: block !important;
      opacity: 1 !important;
      overflow: hidden !important;
      pointer-events: auto !important;
    }

    [class*="formFileInputNativeInput"],
    [class*="formFileInput"] input[type="file"] {
      position: absolute !important;
      inset: 0 !important;
      width: 100% !important;
      height: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      opacity: 0 !important;
      cursor: pointer !important;
      font-size: 0 !important;
      z-index: 5 !important;
      display: block !important;
      pointer-events: auto !important;
    }

    [class*="formFileInputContent"] {
      display: inline-flex !important;
      flex: 0 0 auto !important;
      width: auto !important;
      max-width: none !important;
      min-width: 0 !important;
      height: auto !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      pointer-events: none !important;
      position: relative !important;
      z-index: 1 !important;
    }

    [class*="formFileInputField"] [class*="fileName"],
    [class*="formFileInputField"] [class*="FileName"],
    [class*="formFileInputField"] [class*="filePreview"],
    [class*="formFileInputField"] [class*="FilePreview"] {
      flex: 1 1 auto !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      line-height: 1.4 !important;
      white-space: normal !important;
      word-break: break-word !important;
      overflow: visible !important;
      text-overflow: clip !important;
    }

    [class*="formFileInputField"]:not([data-sg-file-state="uploaded"]) [class*="formFileInputButton"] {
      display: inline-flex !important;
    }

    [class*="formFileInputField"]:not([data-sg-file-state="uploaded"]) .sg-sw-file-status {
      display: block !important;
    }

    /* Selected file: Shopify reuses a single span for both the Choose File
       label and the filename, swapping only its class and often leaving the
       stale "Choose File" text behind. Never surface that node — hide it and
       show the name we read off the input instead. */
    [class*="formFileInputField"][data-sg-file-state="uploaded"] .sg-sw-file-status,
    [class*="formFileInputField"][data-sg-file-state="uploaded"] [class*="fileName"],
    [class*="formFileInputField"][data-sg-file-state="uploaded"] [class*="FileName"],
    [class*="formFileInputField"][data-sg-file-state="uploaded"] [class*="filePreview"],
    [class*="formFileInputField"][data-sg-file-state="uploaded"] [class*="FilePreview"] {
      display: none !important;
    }

    [class*="formFileInputField"][data-sg-file-state="uploaded"] .sg-sw-file-name {
      display: block !important;
      flex: 1 1 auto !important;
      min-width: 0 !important;
      color: #ffffff !important;
      text-align: left !important;
      white-space: normal !important;
      word-break: break-word !important;
      overflow: visible !important;
      text-overflow: clip !important;
    }

    [class*="formFileInputField"][data-sg-file-state="uploaded"] [class*="formFileInputContent"] {
      display: flex !important;
      flex: 1 1 auto !important;
      width: 100% !important;
      max-width: 100% !important;
      align-items: center !important;
      justify-content: space-between !important;
      gap: 0.75rem !important;
      pointer-events: none !important;
    }

    [class*="formFileInputField"][data-sg-file-state="uploaded"] [class*="formFileInputButton"] {
      display: none !important;
    }

    [class*="formFileInputField"][data-sg-file-state="uploaded"] [class*="formFileInputLabel"],
    [class*="formFileInputField"][data-sg-file-state="uploaded"] [class*="formFileInputNativeInput"],
    [class*="formFileInputField"][data-sg-file-state="uploaded"] input[type="file"] {
      pointer-events: none !important;
      z-index: 0 !important;
    }

    [class*="formFileInputField"][data-sg-file-state="uploaded"] .sg-sw-file-remove,
    [class*="formFileInputField"][data-sg-file-state="uploaded"] [class*="formFileInputRemove"],
    [class*="formFileInputField"][data-sg-file-state="uploaded"] [class*="formFileInputCancel"] {
      position: relative !important;
      z-index: 4 !important;
      pointer-events: auto !important;
      flex: 0 0 auto !important;
      margin-left: auto !important;
      display: inline-flex !important;
    }

    [class*="formFileInputField"]:hover {
      background-color: rgba(255, 255, 255, 0.08) !important;
      color: #ffffff !important;
      border-color: transparent !important;
    }

    [class*="formFileInputButton"] {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      flex: 0 0 auto !important;
      margin: 0 !important;
      padding: 0.35rem 0.75rem !important;
      color: #ffffff !important;
      font-weight: 700 !important;
      font-size: 0.9rem !important;
      line-height: 1.4 !important;
      background-color: rgba(255, 255, 255, 0.15) !important;
      border: 1px solid rgba(255, 255, 255, 0.45) !important;
      border-radius: 0 !important;
      min-height: 0 !important;
      width: auto !important;
      box-shadow: none !important;
      pointer-events: none !important;
      white-space: nowrap !important;
    }

    .sg-sw-file-status {
      color: #ffffff !important;
      font-weight: 700 !important;
      font-size: 0.9rem !important;
      line-height: 1.4 !important;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      flex: 1 1 auto !important;
      min-width: 9rem !important;
      width: auto !important;
      text-align: left !important;
      white-space: nowrap !important;
      overflow: visible !important;
      text-overflow: clip !important;
      pointer-events: none !important;
      position: relative !important;
      z-index: 1 !important;
    }

    .sg-sw-actions {
      display: flex !important;
      flex-wrap: wrap !important;
      align-items: center !important;
      gap: 0.75rem !important;
      grid-column: 1 / -1 !important;
      margin-top: 0.5rem !important;
      margin-bottom: 20px !important;
      width: 100% !important;
    }

    .sg-sw-actions button[type="submit"],
    .sg-sw-actions [data-testid="btn-form-submit"],
    .sg-sw-actions [class*="formSubmitButton"] {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

    .sg-sw-draft-btn {
      color: #ffffff !important;
      background: transparent !important;
      border: 2px solid #ffffff !important;
      border-radius: 4px !important;
      padding: 0.65rem 1.25rem !important;
      min-height: var(--sg-button-height, 3.45rem) !important;
      box-sizing: border-box !important;
      font-size: 1rem !important;
      line-height: 1.5 !important;
      font-weight: 600 !important;
      text-transform: uppercase !important;
      letter-spacing: 0.04em !important;
      cursor: pointer !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .sg-sw-draft-btn:hover {
      background: rgba(255, 255, 255, 0.12) !important;
    }

    .sg-sw-draft-status {
      color: #ffffff !important;
      font-size: 0.9rem !important;
      font-weight: 600 !important;
      line-height: 1.4 !important;
      margin: 0 !important;
      flex: 1 1 auto !important;
      min-width: 0 !important;
    }

    .sg-sw-file-name {
      color: #ffffff !important;
      font-weight: 700 !important;
      font-size: 0.9rem !important;
      line-height: 1.4 !important;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      flex: 1 1 auto !important;
      min-width: 0 !important;
      text-align: left !important;
      white-space: normal !important;
      word-break: break-word !important;
      pointer-events: none !important;
    }

    .sg-sw-file-help {
      margin: 0.5rem 0 0 0 !important;
      color: #ffffff !important;
      font-weight: 700 !important;
      font-size: 0.9rem !important;
      line-height: 1.5 !important;
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      padding: 0 !important;
    }

    [class*="formFileInput"] [class*="fileName"],
    [class*="formFileInput"] [class*="FileName"],
    [class*="formFileInput"] [class*="filePreview"],
    [class*="formFileInput"] [class*="FilePreview"],
    [class*="formFileInput"] [class*="uploaded"] {
      color: #ffffff !important;
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
    }

    [class*="formFileInput"] button:not([class*="formFileInputField"]),
    [class*="formFileInput"] [class*="remove"],
    [class*="formFileInput"] [class*="Remove"],
    [class*="formFileInput"] [class*="clear"],
    [class*="formFileInput"] [class*="Clear"],
    [class*="formFileInput"] [class*="delete"],
    [class*="formFileInput"] [class*="Delete"],
    [class*="formFileInputField"] button:not([class*="formFileInputButton"]),
    [class*="formFileInputField"] .sg-sw-file-remove,
    [class*="formFileInputField"] [class*="formFileInputRemove"],
    [class*="formFileInputField"] [class*="formFileInputCancel"],
    [class*="formFileInputField"] [role="button"]:not([class*="formFileInputButton"]) {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      background: transparent !important;
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
      color: #ffffff !important;
      padding: 0 !important;
      margin: 0 !important;
      min-width: 1.275rem !important;
      min-height: 1.275rem !important;
      width: 1.275rem !important;
      height: 1.275rem !important;
      flex: 0 0 auto !important;
      flex-shrink: 0 !important;
      align-self: center !important;
      border-radius: 0 !important;
      -webkit-appearance: none !important;
      appearance: none !important;
    }

    [class*="formFileInputField"] .sg-sw-file-remove svg,
    [class*="formFileInputField"] [class*="formFileInputRemove"] svg,
    [class*="formFileInputField"] [class*="formFileInputCancel"] svg,
    [class*="formFileInputField"] button:not([class*="formFileInputButton"]) svg {
      display: block !important;
      width: 1.275rem !important;
      height: 1.275rem !important;
      flex-shrink: 0 !important;
      overflow: visible !important;
    }

    [class*="formFileInputField"] .sg-sw-file-remove svg rect,
    [class*="formFileInputField"] [class*="formFileInputRemove"] svg rect,
    [class*="formFileInputField"] [class*="formFileInputCancel"] svg rect,
    [class*="formFileInputField"] button:not([class*="formFileInputButton"]) svg rect {
      display: none !important;
    }

    [class*="formFileInput"] button:not([class*="formFileInputField"]) *,
    [class*="formFileInputField"] button:not([class*="formFileInputButton"]) * {
      background: transparent !important;
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
    }

    [class*="formFileInput"] button:not([class*="formFileInputField"]) svg,
    [class*="formFileInput"] button:not([class*="formFileInputField"]) svg path,
    [class*="formFileInput"] [class*="remove"] svg path,
    [class*="formFileInput"] [class*="Remove"] svg path,
    [class*="formFileInput"] [class*="clear"] svg path,
    [class*="formFileInput"] [class*="Clear"] svg path,
    [class*="formFileInputField"] button:not([class*="formFileInputButton"]) svg,
    [class*="formFileInputField"] button:not([class*="formFileInputButton"]) svg path {
      fill: #ffffff !important;
      stroke: #ffffff !important;
      color: #ffffff !important;
    }

    [class*="formFileInputField"] .sg-sw-file-remove svg circle,
    [class*="formFileInputField"] [class*="formFileInputRemove"] svg circle,
    [class*="formFileInputField"] [class*="formFileInputCancel"] svg circle,
    [class*="formFileInputField"] .sg-sw-file-remove svg path,
    [class*="formFileInputField"] [class*="formFileInputRemove"] svg path,
    [class*="formFileInputField"] [class*="formFileInputCancel"] svg path {
      fill: none !important;
      stroke: #ffffff !important;
      stroke-width: 1.25 !important;
    }

    a {
      color: #ffffff !important;
    }

    [role="alert"],
    .error,
    [data-testid*="error"],
    [class*="formError"],
    output[class*="formError"] {
      color: #ffb4b4 !important;
      font-weight: 700 !important;
      display: block !important;
      margin-top: 0.35rem !important;
    }

    [class*="withError"] {
      scroll-margin-top: 6rem;
    }

    [class*="successMessage"],
    [class*="SuccessMessage"],
    [data-testid*="success"] {
      background: #1a6421 !important;
      color: #ffffff !important;
      border: none !important;
      box-shadow: none !important;
      padding: 0 !important;
      text-align: left !important;
    }

    [data-testid="form"][data-sg-success-upgraded="true"],
    .sg-sw-success-panel {
      min-height: 24rem !important;
      display: flex !important;
      flex-direction: column !important;
      justify-content: center !important;
      align-items: flex-start !important;
      background: #1a6421 !important;
      color: #ffffff !important;
      width: 100% !important;
      box-sizing: border-box !important;
    }

    .sg-sw-success-title {
      margin: 0 0 1.25rem !important;
      color: #ffffff !important;
      font-size: clamp(2rem, 5vw, 3rem) !important;
      font-weight: 700 !important;
      line-height: 1.1 !important;
      letter-spacing: 0.02em !important;
      text-transform: uppercase !important;
    }

    .sg-sw-success-lead {
      margin: 0 !important;
      max-width: 42rem !important;
      color: #ffffff !important;
      font-size: 0.95rem !important;
      font-weight: 700 !important;
      line-height: 1.65 !important;
    }
  `;

  const FILE_HELP_TEXT =
    'Required. PDF, JPG, or PNG up to 10MB. Wait for the file name to appear in the field before submitting.';

  const SUBMIT_LABEL = 'SUBMIT';
  const SUBMITTING_LABEL = 'SUBMITTING...';
  const SUCCESS_TITLE = 'SUCCESS';
  const SUCCESS_SUBTITLE =
    'Thank you for your submission. We will have one of our staff members get back to you as soon as possible.';

  function compactSubmitLabel(text) {
    return (text || '').replace(/\s+/g, '').toLowerCase();
  }

  function isSubmitLikeLabel(text) {
    const compact = compactSubmitLabel(text);
    if (!compact || compact === 'submitting' || compact === 'submitting...') return false;
    return /^(send|submit)+$/.test(compact);
  }

  function getSuccessTitle() {
    return findHost()?.dataset?.sgSuccessTitle || SUCCESS_TITLE;
  }

  function getSuccessSubtitle() {
    return findHost()?.dataset?.sgSuccessSubtitle || SUCCESS_SUBTITLE;
  }

  function isDefaultSuccessHeading(text) {
    const trimmed = (text || '').trim().toLowerCase();
    return trimmed === 'success' || trimmed === 'successfully submitted';
  }

  function isDefaultSuccessBody(text) {
    const trimmed = (text || '').trim().toLowerCase();
    return (
      trimmed.includes('form has been submitted') ||
      trimmed.includes('thank you') ||
      trimmed.includes('staff members will review') ||
      trimmed.includes('staff members will get back') ||
      trimmed === SUCCESS_SUBTITLE.toLowerCase()
    );
  }

  function getFormValidationErrors(form) {
    if (!form) return [];

    return [...form.querySelectorAll(
      '[role="alert"], [data-testid*="error"], [class*="errorMessage"], [class*="ErrorMessage"], [class*="formError"]'
    )].filter((el) => (el.textContent || '').trim());
  }

  function focusValidationErrors(form) {
    if (!form) return false;

    const errors = getFormValidationErrors(form);
    if (!errors.length) return false;

    const firstError = errors[0];
    const field =
      firstError.closest(
        '[class*="formFieldContainer"], [class*="formFileInput"], [class*="selectContainer"], [class*="formPhoneInputContainer"], [data-testid="date-birthday"]'
      ) || firstError;

    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    field.style.outline = '2px solid #ffb4b4';
    field.style.outlineOffset = '4px';
    window.setTimeout(() => {
      field.style.removeProperty('outline');
      field.style.removeProperty('outline-offset');
    }, 5000);

    return true;
  }

  function hasFormSuccessState(form) {
    if (!form) return false;

    if (form.querySelector('[data-testid*="success"], [class*="successMessage"], [class*="SuccessMessage"]')) {
      return true;
    }

    const heading = [...form.querySelectorAll('h1, h2, h3, h4, p, span')].find((el) =>
      isDefaultSuccessHeading(el.textContent)
    );
    if (!heading) return false;

    return [...form.querySelectorAll('p, span, div')].some(
      (el) => el !== heading && !heading.contains(el) && isDefaultSuccessBody(el.textContent)
    );
  }

  function hideServiceWarrantyPageChrome() {
    document.body.classList.add('sg-sw-form-success');
    document
      .querySelectorAll(
        '.service-warranty-section--header, .service-warranty-section--footer, [id*="service_warranty_form"], [id*="service_warranty_footer"]'
      )
      .forEach((section) => {
        section.style.display = 'none';
        section.setAttribute('aria-hidden', 'true');
      });
  }

  function findSuccessForm(root) {
    let successForm = null;

    walkShadowRoots(root, (node) => {
      const banner = node.querySelector?.(
        '[data-testid*="success"], [class*="successMessage"], [class*="SuccessMessage"]'
      );
      if (banner) {
        successForm = banner;
        return;
      }

      const form = node.querySelector?.('[data-testid="form"]');
      if (!form) return;
      if (form.dataset.sgSuccessUpgraded === 'true' || hasFormSuccessState(form)) {
        successForm = form;
      }
    });

    return successForm;
  }

  function getEmbedStep() {
    const embed = document.querySelector('shopify-forms-embed');
    return embed?.shadowRoot?.querySelector('#app-embed')?.getAttribute('data-current-step') || null;
  }

  let successStepObserverBound = false;

  function bindSuccessStepObserver() {
    if (successStepObserverBound) return;

    const embed = document.querySelector('shopify-forms-embed');
    const appEmbed = embed?.shadowRoot?.querySelector('#app-embed');
    if (!appEmbed) return;

    successStepObserverBound = true;

    const onSuccessStep = () => {
      if (appEmbed.getAttribute('data-current-step') !== 'success') return;
      hideServiceWarrantyPageChrome();
      const currentHost = findHost();
      if (currentHost) {
        injectShadowStyles(currentHost);
        customizeSuccessState(currentHost);
      }
    };

    const stepObserver = new MutationObserver(onSuccessStep);
    stepObserver.observe(appEmbed, { attributes: true, attributeFilter: ['data-current-step'] });
    onSuccessStep();
  }

  function isPageInSuccessState(root) {
    return (
      document.body.classList.contains('sg-sw-form-success') ||
      getEmbedStep() === 'success' ||
      Boolean(findSuccessForm(root))
    );
  }

  function customizeSuccessContainer(container, successRoot) {
    const scope =
      successRoot?.matches?.('[data-testid*="success"], [class*="successMessage"], [class*="SuccessMessage"]') ?
        successRoot
      : container;

    if (!scope) return false;

    container.querySelectorAll(':scope > *').forEach((child) => {
      if (child === scope || child.contains(scope) || scope.contains(child)) return;
      child.style.display = 'none';
      child.setAttribute('aria-hidden', 'true');
    });

    let title = scope.querySelector('.sg-sw-success-title');
    if (!title) {
      const existingHeading = [...scope.querySelectorAll('h1, h2, h3, h4, p, span')].find(
        (el) => isDefaultSuccessHeading(el.textContent) && !el.classList.contains('sg-sw-success-lead')
      );
      if (existingHeading && (existingHeading.textContent || '').trim().length < 40) {
        title = existingHeading;
        title.classList.add('sg-sw-success-title');
      } else {
        title = document.createElement('h2');
        title.className = 'sg-sw-success-title';
        scope.prepend(title);
      }
    }

    let lead = scope.querySelector('.sg-sw-success-lead');
    if (!lead) {
      const existingBody = [...scope.querySelectorAll('p, span, div')].find(
        (el) =>
          isDefaultSuccessBody(el.textContent) &&
          el !== title &&
          !title.contains(el) &&
          !el.querySelector('.sg-sw-success-title')
      );
      if (existingBody) {
        lead = existingBody;
        lead.classList.add('sg-sw-success-lead');
      } else {
        lead = document.createElement('p');
        lead.className = 'sg-sw-success-lead';
        title.insertAdjacentElement('afterend', lead);
      }
    }

    title.textContent = getSuccessTitle();
    lead.textContent = getSuccessSubtitle();

    scope.querySelectorAll('h1, h2, h3, h4, p, span, div, svg, img, button').forEach((el) => {
      if (el === title || el === lead || title.contains(el) || lead.contains(el)) return;
      if (el.contains(title) || el.contains(lead)) return;
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    });

    scope.classList.add('sg-sw-success-panel');
    scope.style.background = '#1a6421';
    scope.style.color = '#ffffff';
    scope.style.minHeight = '24rem';
    scope.style.display = 'flex';
    scope.style.flexDirection = 'column';
    scope.style.justifyContent = 'center';
    scope.style.alignItems = 'flex-start';
    scope.style.width = '100%';
    scope.style.boxSizing = 'border-box';

    container.style.background = '#1a6421';
    container.style.minHeight = '24rem';
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.justifyContent = 'center';
    container.style.alignItems = 'flex-start';
    container.style.width = '100%';
    container.style.boxSizing = 'border-box';
    container.dataset.sgSuccessUpgraded = 'true';
    clearFormDraft();
    hideServiceWarrantyPageChrome();
    return true;
  }

  function syncNativeDateFields(root) {
    walkShadowRoots(root, (node) => {
      node.querySelectorAll?.('[data-testid="date-birthday"]').forEach((group) => {
        const native = group.querySelector('.sg-sw-native-date');
        const container =
          group.querySelector('[class*="dateFieldContainer"]') ||
          group.querySelector('._dateFieldContainer_rzr7e_5');
        const inputs = container?.querySelectorAll('input[type="text"]');
        if (!native?.value || !inputs || inputs.length < 3) return;

        const [yyyy, mm, dd] = native.value.split('-');
        setInputValue(inputs[0], mm);
        setInputValue(inputs[1], dd);
        setInputValue(inputs[2], yyyy);
      });
    });
  }

  function syncStateFieldValue(root) {
    walkShadowRoots(root, (node) => {
      const select = node.querySelector?.('.sg-sw-state-select');
      const input = node.querySelector?.('[data-testid="field-custom#state"]');
      if (!select || !input) return;
      setInputValue(input, select.value);
    });
  }

  function syncFormFieldsBeforeSubmit(root) {
    syncNativeDateFields(root);
    syncStateFieldValue(root);
  }

  function customizeSuccessState(root) {
    let foundSuccess = false;

    walkShadowRoots(root, (node) => {
      const successRoot = node.querySelector?.(
        '[data-testid*="success"], [class*="successMessage"], [class*="SuccessMessage"]'
      );
      const form = node.querySelector?.('[data-testid="form"]');

      if (successRoot) {
        foundSuccess = true;
        const container = successRoot.closest('[data-testid="form"]') || form || successRoot.parentElement || successRoot;
        customizeSuccessContainer(container, successRoot);
        return;
      }

      if (!form) return;

      if (form.dataset.sgSuccessUpgraded === 'true') {
        foundSuccess = true;
        hideServiceWarrantyPageChrome();
        return;
      }

      if (!hasFormSuccessState(form)) return;

      const heading = [...form.querySelectorAll('h1, h2, h3, h4, p, span')].find((el) =>
        isDefaultSuccessHeading(el.textContent)
      );
      if (!heading) return;

      foundSuccess = true;
      customizeSuccessContainer(form, heading.closest('[class*="success"]') || heading.parentElement || form);
    });

    if (foundSuccess) {
      hideServiceWarrantyPageChrome();
    }
  }

  function setSubmitButtonLabel(btn, label) {
    if (!btn) return;

    const hasSingleTextNode =
      btn.childNodes.length === 1 && btn.firstChild?.nodeType === Node.TEXT_NODE;

    if (btn.textContent === label && hasSingleTextNode) return;

    btn.textContent = label;
  }

  function applySubmitButtonStyles(btn) {
    btn.style.width = 'auto';
    btn.style.display = 'inline-flex';
    btn.style.justifySelf = 'start';
    btn.style.alignSelf = 'start';
    btn.style.maxWidth = 'none';
    btn.style.marginBottom = '20px';

    if (btn.dataset.sgSubmitState === 'submitting') {
      return;
    }
  }

  function styleSubmitButton(btn) {
    if (!btn) return;

    applySubmitButtonStyles(btn);

    if (btn.dataset.sgSubmitState === 'submitting') {
      setSubmitButtonLabel(btn, SUBMITTING_LABEL);
      return;
    }

    const text = btn.textContent || '';
    const hasSingleTextNode =
      btn.childNodes.length === 1 && btn.firstChild?.nodeType === Node.TEXT_NODE;

    if (isSubmitLikeLabel(text) || (/submit/i.test(text) && !/submitting/i.test(text))) {
      if (btn.textContent !== SUBMIT_LABEL || !hasSingleTextNode) {
        setSubmitButtonLabel(btn, SUBMIT_LABEL);
      }
    }
  }

  function resetSubmitButton(btn) {
    if (!btn) return;
    btn.dataset.sgSubmitState = 'idle';
    setSubmitButtonLabel(btn, SUBMIT_LABEL);
    applySubmitButtonStyles(btn);
  }

  function bindSubmitHandling(root) {
    walkShadowRoots(root, (node) => {
      const form = node.querySelector?.('[data-testid="form"]');
      if (!form || form.dataset.sgSubmitBound === 'true') return;

      const submitBtn =
        form.querySelector('button[type="submit"]') || form.querySelector('[data-testid="btn-form-submit"]');
      if (!submitBtn) return;

      form.dataset.sgSubmitBound = 'true';

      const markSubmitting = () => {
        submitBtn.dataset.sgSubmitState = 'submitting';
        setSubmitButtonLabel(submitBtn, SUBMITTING_LABEL);
        applySubmitButtonStyles(submitBtn);
      };

      const submitLabelObserver = new MutationObserver(() => {
        if (submitBtn.dataset.sgSubmitState !== 'submitting') return;
        if (submitBtn.textContent !== SUBMITTING_LABEL) {
          setSubmitButtonLabel(submitBtn, SUBMITTING_LABEL);
        }
      });
      submitLabelObserver.observe(submitBtn, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      const maybeResetSubmit = () => {
        if (submitBtn.dataset.sgSubmitState !== 'submitting') return;

        const errors = getFormValidationErrors(form);
        const hasErrors = errors.length > 0;
        const hasSuccess = hasFormSuccessState(form);
        const label = compactSubmitLabel(submitBtn.textContent);
        const shopifyRestoredLabel =
          label !== 'submitting' && label !== 'submitting...' && isSubmitLikeLabel(submitBtn.textContent);

        if (hasErrors) {
          resetSubmitButton(submitBtn);
          focusValidationErrors(form);
          return;
        }

        if (hasSuccess || shopifyRestoredLabel) {
          resetSubmitButton(submitBtn);
        }
      };

      const syncAndMarkSubmitting = () => {
        syncFormFieldsBeforeSubmit(root);
        markSubmitting();
        window.setTimeout(() => {
          if (submitBtn.dataset.sgSubmitState !== 'submitting') return;
          if (focusValidationErrors(form)) {
            resetSubmitButton(submitBtn);
          }
        }, 250);
      };

      form.addEventListener('submit', syncAndMarkSubmitting, true);
      submitBtn.addEventListener('click', () => {
        syncFormFieldsBeforeSubmit(root);
        window.setTimeout(markSubmitting, 0);
      });

      const completionObserver = new MutationObserver(() => {
        maybeResetSubmit();
        if (!hasFormSuccessState(form)) return;
        const currentHost = findHost();
        if (currentHost) {
          customizeSuccessState(currentHost);
        }
      });
      completionObserver.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-busy', 'aria-disabled'],
      });

      window.setTimeout(() => {
        if (submitBtn.dataset.sgSubmitState === 'submitting') {
          resetSubmitButton(submitBtn);
        }
      }, 30000);
    });
  }

  const US_STATES = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
    'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
    'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
    'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
    'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
    'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
    'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
    'Wisconsin', 'Wyoming',
  ];

  const FULL_WIDTH_MATCHERS = [
    'request type',
    'chuck type',
    'additional part',
    'description of failure',
    'picture of failure',
    'warranty return',
    'warranty policy',
    'agree to terms',
  ];

  const observedShadowNodes = new WeakSet();

  function walkShadowRoots(root, callback) {
    callback(root);
    if (root.shadowRoot) {
      walkShadowRoots(root.shadowRoot, callback);
    }
    root.querySelectorAll?.('*').forEach((el) => {
      if (el.shadowRoot) {
        walkShadowRoots(el.shadowRoot, callback);
      }
    });
  }

  function observeShadowRoots(root, callback) {
    walkShadowRoots(root, (node) => {
      if (!node || observedShadowNodes.has(node)) return;
      observedShadowNodes.add(node);

      const observer = new MutationObserver(callback);
      // childList only — watching attributes/characterData re-triggers on our own style writes
      // and freezes the page in an infinite theme loop.
      observer.observe(node, {
        childList: true,
        subtree: true,
      });
    });
  }

  function setInputValue(input, value) {
    if (!input) return;
    const proto = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    proto?.set?.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function injectShadowStyles(root) {
    walkShadowRoots(root, (node) => {
      if (!node.host) return;
      if (node.host.tagName === 'SHOP-LEAD-CAPTURE') return;

      let style = node.querySelector?.('#sg-sw-form-styles');
      if (!style) {
        style = document.createElement('style');
        style.id = 'sg-sw-form-styles';
        node.appendChild(style);
      }
      style.textContent = SHADOW_CSS;
    });
  }

  function centerFormEmbed(root) {
    const embed = root.querySelector?.('shopify-forms-embed') || document.querySelector('shopify-forms-embed');
    if (embed) {
      embed.style.width = '100%';
      embed.style.maxWidth = '100%';
      embed.style.marginLeft = 'auto';
      embed.style.marginRight = 'auto';
      embed.style.display = 'block';
      embed.style.boxSizing = 'border-box';
      embed.style.overflow = 'visible';
    }

    walkShadowRoots(root, (node) => {
      if (node.host?.tagName === 'SHOPIFY-FORMS-EMBED') {
        node.host.style.width = '100%';
        node.host.style.maxWidth = '100%';
        node.host.style.marginLeft = 'auto';
        node.host.style.marginRight = 'auto';
        node.host.style.display = 'block';
        node.host.style.boxSizing = 'border-box';
        node.host.style.overflow = 'visible';
      }
    });
  }

  function upgradePoField(root) {
    walkShadowRoots(root, (node) => {
      const po =
        node.querySelector?.('#custom\\#po') ||
        node.querySelector?.('[data-testid="field-custom#po"]') ||
        node.querySelector?.('input[id="custom#po"]');
      if (!po) return;

      if (po.type !== 'text') {
        po.type = 'text';
      }
      po.inputMode = 'text';
      po.removeAttribute('step');
      po.removeAttribute('min');
      po.removeAttribute('max');
      po.removeAttribute('pattern');
      po.setAttribute('autocomplete', 'off');
    });
  }

  function upgradeDatePickers(root) {
    walkShadowRoots(root, (node) => {
      node.querySelectorAll?.('[data-testid="date-birthday"]').forEach((group) => {
        if (group.dataset.sgDateUpgraded === 'true') return;

        const container =
          group.querySelector('[class*="dateFieldContainer"]') ||
          group.querySelector('._dateFieldContainer_rzr7e_5');
        const inputs = container?.querySelectorAll('input[type="text"]');
        if (!inputs || inputs.length < 3) return;

        const [mmInput, ddInput, yyyyInput] = inputs;
        const native = document.createElement('input');
        native.type = 'date';
        native.className = 'sg-sw-native-date';

        const mm = (mmInput.value || '').padStart(2, '0');
        const dd = (ddInput.value || '').padStart(2, '0');
        const yyyy = yyyyInput.value || '';
        if (yyyy && mm && dd) {
          native.value = `${yyyy}-${mm}-${dd}`;
        }

        native.addEventListener('change', () => {
          if (!native.value) return;
          const [y, m, d] = native.value.split('-');
          setInputValue(mmInput, m);
          setInputValue(ddInput, d);
          setInputValue(yyyyInput, y);
        });

        // Clicking anywhere in the field opens the calendar, not just the icon.
        if (typeof native.showPicker === 'function') {
          native.addEventListener('click', () => {
            try {
              native.showPicker();
            } catch (_) {
              /* Already open, or the browser refused outside a user gesture. */
            }
          });
        }

        container.style.display = 'none';
        container.setAttribute('aria-hidden', 'true');
        group.appendChild(native);
        group.dataset.sgDateUpgraded = 'true';
      });
    });
  }

  function upgradeStateField(root) {
    walkShadowRoots(root, (node) => {
      const input = node.querySelector?.('[data-testid="field-custom#state"]');
      if (!input || input.dataset.sgStateUpgraded === 'true' || input.parentNode?.querySelector('.sg-sw-state-select')) return;

      const select = document.createElement('select');
      select.className = 'sg-sw-state-select _formInputField_nag3b_7';
      select.id = 'sg-sw-state-select';
      select.setAttribute('aria-labelledby', input.getAttribute('aria-labelledby') || 'label-custom#state');

      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select a State';
      select.appendChild(placeholder);

      US_STATES.forEach((state) => {
        const option = document.createElement('option');
        option.value = state;
        option.textContent = state;
        select.appendChild(option);
      });

      if (input.value) {
        select.value = input.value;
      }

      select.addEventListener('change', () => {
        setInputValue(input, select.value);
      });

      input.style.position = 'absolute';
      input.style.opacity = '0';
      input.style.height = '0';
      input.style.width = '0';
      input.style.pointerEvents = 'none';
      input.setAttribute('aria-hidden', 'true');
      input.tabIndex = -1;
      input.parentNode.insertBefore(select, input);
      input.dataset.sgStateUpgraded = 'true';
    });
  }

  function fixFieldLabels(root) {
    walkShadowRoots(root, (node) => {
      node.querySelectorAll?.('label[id^="label-custom#zipcode"], label[for*="zipcode"]').forEach((label) => {
        if (/^zip\s*code$/i.test((label.textContent || '').trim()) || label.textContent.trim() === 'Zipcode') {
          label.textContent = 'Zip Code';
        }
      });

      const zipInput = node.querySelector?.('[data-testid="field-custom#zipcode"]');
      if (zipInput) {
        const zipLabel = zipInput.getAttribute('aria-label');
        if (zipLabel && /^zip\s*code$/i.test(zipLabel.trim())) {
          zipInput.setAttribute('aria-label', 'Zip Code');
        }
      }
    });
  }

  function hideDuplicateFormChrome(root) {
    const embed =
      root.querySelector?.('shopify-forms-embed') ||
      (root.matches?.('shopify-forms-embed') ? root : document.querySelector('shopify-forms-embed'));
    if (!embed?.shadowRoot) return;

    walkShadowRoots(embed.shadowRoot, (node) => {
      node.querySelectorAll?.('h1, h2, h3, h4, p, legend').forEach((el) => {
        const text = (el.textContent || '').trim().toLowerCase();
        if (
          text.includes('service & warranty request form') ||
          text === 'please call or email to request rma!' ||
          text === 'request form'
        ) {
          el.style.display = 'none';
          el.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

  function isFullWidthBlock(el) {
    const text = (el.textContent || '').trim().toLowerCase();
    if (!text) return false;
    return FULL_WIDTH_MATCHERS.some((needle) => text.includes(needle));
  }

  const FILE_ICON_SIZE = '1.275rem';
  const FILE_REMOVE_ICON_SVG =
    '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
    '<circle cx="10" cy="10" r="7" fill="none" stroke="#ffffff" stroke-width="1.25"/>' +
    '<path d="M7.25 7.25l5.5 5.5M12.75 7.25l-5.5 5.5" fill="none" stroke="#ffffff" stroke-width="1.25" stroke-linecap="round"/>' +
    '</svg>';

  const FILE_PLACEHOLDER_TEXT_RE = /^(?:choose file|no file chosen|upload a file|upload file)$/i;

  function findNativeFileRemoveButton(fieldRow) {
    const native = [
      ...fieldRow.querySelectorAll('[class*="formFileInputRemove"], [class*="formFileInputCancel"]'),
    ].find((btn) => btn.dataset.sgFallbackRemove !== 'true');
    if (native) return native;

    return (
      [...fieldRow.querySelectorAll('button:not([class*="formFileInputButton"])')].find(
        (btn) => btn.dataset.sgFallbackRemove !== 'true' && Boolean(btn.querySelector('svg'))
      ) || null
    );
  }

  // Shopify's own cancel button wins; our fallback only fills in when it's absent.
  function findFileRemoveButton(fieldRow) {
    return (
      findNativeFileRemoveButton(fieldRow) ||
      fieldRow.querySelector('button.sg-sw-file-remove[data-sg-fallback-remove="true"]')
    );
  }

  // Shopify reuses one span for both the Choose File label and the filename,
  // swapping only its class, and the text it leaves in that node is frequently
  // the stale "Choose File" placeholder. So the node is never trusted for
  // display: it gets hidden, and the name read off the input is rendered in a
  // span we own.
  function showFileName(fieldRow, content, nativeName, name) {
    const nameStyles = {
      display: 'block',
      flex: '1 1 auto',
      'min-width': '0',
      margin: '0',
      color: '#ffffff',
      'text-align': 'left',
      'white-space': 'normal',
      'word-break': 'break-word',
      overflow: 'visible',
    };

    if (nativeName) {
      nativeName.style.setProperty('display', 'none', 'important');
    }

    let custom = fieldRow.querySelector('.sg-sw-file-name');
    if (!custom) {
      custom = document.createElement('span');
      custom.className = 'sg-sw-file-name';
      (content || fieldRow).appendChild(custom);
    }
    if (custom.textContent !== name) {
      custom.textContent = name;
    }
    Object.entries(nameStyles).forEach(([prop, value]) => {
      custom.style.setProperty(prop, value, 'important');
    });
    return custom;
  }

  function placeRemoveButton(fieldRow, content, addBtn, removeBtn) {
    if (!removeBtn) return;

    styleRemoveButton(removeBtn);
    removeBtn.style.setProperty('display', 'inline-flex', 'important');
    removeBtn.style.setProperty('pointer-events', 'auto', 'important');
    removeBtn.style.setProperty('margin-left', 'auto', 'important');

    if (content) {
      if (addBtn && addBtn.parentElement !== content) {
        content.appendChild(addBtn);
      }
      content.appendChild(removeBtn);
    } else {
      fieldRow.appendChild(removeBtn);
    }
  }

  // Bounded polling rather than an observer, so this can never loop against
  // Shopify's own re-render of the field.
  function awaitNativeRemoveButton(fieldRow, fileInput) {
    if (fieldRow.dataset.sgAwaitingRemove === 'true') return;
    fieldRow.dataset.sgAwaitingRemove = 'true';

    const delays = [80, 200, 400, 800, 1500];
    let attempt = 0;

    const check = () => {
      if (fieldRow.dataset.sgFileState !== 'uploaded') {
        delete fieldRow.dataset.sgAwaitingRemove;
        return;
      }

      const content = fieldRow.querySelector('[class*="formFileInputContent"]');
      const addBtn = fieldRow.querySelector('[class*="formFileInputButton"]');
      const native = findNativeFileRemoveButton(fieldRow);

      if (native) {
        removeFallbackRemoveButton(fieldRow);
        placeRemoveButton(fieldRow, content, addBtn, native);
        delete fieldRow.dataset.sgAwaitingRemove;
        return;
      }

      if (attempt < delays.length) {
        window.setTimeout(check, delays[attempt++]);
        return;
      }

      placeRemoveButton(fieldRow, content, addBtn, ensureFallbackRemoveButton(fieldRow, fileInput));
      delete fieldRow.dataset.sgAwaitingRemove;
    };

    window.setTimeout(check, delays[attempt++]);
  }

  function findNativeFileName(fieldRow) {
    return fieldRow.querySelector(
      '[class*="FileName"], [class*="fileName"], [class*="FilePreview"], [class*="filePreview"]'
    );
  }

  function styleRemoveButton(removeBtn) {
    if (
      !removeBtn ||
      removeBtn.matches('[class*="formFileInputButton"]') ||
      removeBtn.matches('[class*="formFileInputField"]')
    ) {
      return;
    }

    removeBtn.classList.add('sg-sw-file-remove');
    removeBtn.style.flex = '0 0 auto';
    removeBtn.style.flexShrink = '0';
    removeBtn.style.alignSelf = 'center';
    removeBtn.style.background = 'transparent';
    removeBtn.style.backgroundColor = 'transparent';
    removeBtn.style.border = 'none';
    removeBtn.style.boxShadow = 'none';
    removeBtn.style.outline = 'none';
    removeBtn.style.borderRadius = '0';
    removeBtn.style.padding = '0';
    removeBtn.style.margin = '0';
    removeBtn.style.minWidth = FILE_ICON_SIZE;
    removeBtn.style.minHeight = FILE_ICON_SIZE;
    removeBtn.style.width = FILE_ICON_SIZE;
    removeBtn.style.height = FILE_ICON_SIZE;
    removeBtn.style.color = '#ffffff';

    if (!removeBtn.dataset.sgRemoveIconUpgraded) {
      removeBtn.innerHTML = FILE_REMOVE_ICON_SVG;
      removeBtn.dataset.sgRemoveIconUpgraded = 'true';
    }

    removeBtn.querySelectorAll('svg').forEach((svg) => {
      svg.style.display = 'block';
      svg.style.width = FILE_ICON_SIZE;
      svg.style.height = FILE_ICON_SIZE;
      svg.style.flexShrink = '0';
      svg.style.overflow = 'visible';
    });
  }

  // Whether a file is actually attached. Deliberately ignores sgLastFileName:
  // that is a display fallback only, and trusting it here would latch the row
  // in the uploaded state after Shopify's "Clear file" empties the input.
  function fileRowHasFile(fieldRow, fileInput) {
    if (fileInput?.files?.length) return true;
    if (extractNativeDisplayedName(findNativeFileName(fieldRow))) return true;
    return Boolean(findNativeFileRemoveButton(fieldRow));
  }

  function extractNativeDisplayedName(nativeName) {
    if (!nativeName) return '';
    const text = (nativeName.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    const uploadedMatch = text.match(/^uploaded:\s*(.+)$/i);
    const name = (uploadedMatch ? uploadedMatch[1] : text).trim();
    // Shopify leaves its placeholder label in the node it also uses for the
    // filename, so placeholder text must never count as a selected file.
    return FILE_PLACEHOLDER_TEXT_RE.test(name) ? '' : name;
  }

  function ensureFallbackRemoveButton(fieldRow, fileInput) {
    let removeBtn = fieldRow.querySelector('button.sg-sw-file-remove[data-sg-fallback-remove="true"]');
    if (removeBtn) return removeBtn;

    removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'sg-sw-file-remove';
    removeBtn.dataset.sgFallbackRemove = 'true';
    removeBtn.setAttribute('aria-label', 'Remove file');
    removeBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const nativeCancel = fieldRow.querySelector(
        '[class*="formFileInputCancel"], [class*="formFileInputRemove"]'
      );
      if (nativeCancel && nativeCancel !== removeBtn) {
        nativeCancel.click();
      }

      try {
        fileInput.value = '';
      } catch (_) {
        /* ignore */
      }
      delete fieldRow.dataset.sgLastFileName;
      fileInput.dispatchEvent(new Event('input', { bubbles: true }));
      fileInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    return removeBtn;
  }

  function removeFallbackRemoveButton(fieldRow) {
    fieldRow.querySelectorAll('button.sg-sw-file-remove[data-sg-fallback-remove="true"]').forEach((btn) => {
      btn.remove();
    });
  }

  function syncFileUploadedLayout(fieldRow, addBtn, status, fileInput) {
    const content =
      fieldRow.querySelector('[class*="formFileInputContent"]') || addBtn?.parentElement || null;
    const nativeName = findNativeFileName(fieldRow);
    const nativeDisplayedName = extractNativeDisplayedName(nativeName);
    const fileName = fileInput?.files?.[0]?.name || nativeDisplayedName;
    const hasFile = fileRowHasFile(fieldRow, fileInput);

    if (hasFile && fileName) {
      fieldRow.dataset.sgLastFileName = fileName;
    }

    const displayName = fileName || fieldRow.dataset.sgLastFileName || '';
    fieldRow.dataset.sgFileState = hasFile ? 'uploaded' : 'empty';
    fieldRow.style.display = 'flex';
    fieldRow.style.alignItems = 'center';
    fieldRow.style.gap = '0.75rem';

    if (hasFile) {
      const name = displayName || 'Selected file';

      // Shopify removes its own Choose File button once a file is attached. When
      // it is still present, hide it so the name isn't rendered twice.
      if (addBtn) {
        addBtn.style.setProperty('display', 'none', 'important');
      }

      if (status) {
        status.textContent = '';
        status.style.setProperty('display', 'none', 'important');
      }

      if (content) {
        content.style.setProperty('display', 'flex', 'important');
        content.style.setProperty('flex', '1 1 auto', 'important');
        content.style.setProperty('width', '100%', 'important');
        content.style.setProperty('align-items', 'center', 'important');
        content.style.setProperty('justify-content', 'space-between', 'important');
        content.style.setProperty('gap', '0.75rem', 'important');
        content.style.setProperty('pointer-events', 'none', 'important');
      }

      showFileName(fieldRow, content, nativeName, name);

      const nativeRemove = findNativeFileRemoveButton(fieldRow);
      if (nativeRemove) {
        // Avoid showing two cancel icons once Shopify renders its own.
        removeFallbackRemoveButton(fieldRow);
        placeRemoveButton(fieldRow, content, addBtn, nativeRemove);
      } else {
        // Shopify renders its cancel button a tick after the change event, so
        // hold off on adding ours until we know it isn't coming.
        awaitNativeRemoveButton(fieldRow, fileInput);
      }
    } else {
      removeFallbackRemoveButton(fieldRow);
      fieldRow.querySelectorAll('.sg-sw-file-name').forEach((el) => el.remove());

      if (addBtn) {
        if (!/^choose file$/i.test((addBtn.textContent || '').trim())) {
          addBtn.textContent = 'Choose File';
        }
        addBtn.setAttribute('aria-label', 'Choose File');
        addBtn.style.removeProperty('display');
        addBtn.style.removeProperty('flex');
        addBtn.style.removeProperty('justify-content');
        addBtn.style.removeProperty('background');
        addBtn.style.removeProperty('border');
        addBtn.style.removeProperty('box-shadow');
        addBtn.style.removeProperty('padding');
        addBtn.style.removeProperty('pointer-events');
        addBtn.style.removeProperty('white-space');
        addBtn.style.removeProperty('word-break');
        addBtn.style.removeProperty('text-align');
      }

      if (status) {
        status.textContent = 'No file chosen';
        status.style.removeProperty('display');
      }

      if (content) {
        content.style.removeProperty('display');
        content.style.removeProperty('flex');
        content.style.removeProperty('width');
        content.style.removeProperty('align-items');
        content.style.removeProperty('justify-content');
        content.style.removeProperty('gap');
        content.style.setProperty('pointer-events', 'none', 'important');
      }

      delete fieldRow.dataset.sgLastFileName;

      if (nativeName) {
        nativeName.style.removeProperty('display');
      }
    }

    const fileLabel = fieldRow.querySelector('[class*="formFileInputLabel"]') || fileInput?.closest?.('label');
    if (fileLabel) {
      fileLabel.style.setProperty('pointer-events', hasFile ? 'none' : 'auto', 'important');
      fileLabel.style.setProperty('z-index', hasFile ? '0' : '5', 'important');
    }
    if (fileInput) {
      fileInput.style.setProperty('pointer-events', hasFile ? 'none' : 'auto', 'important');
      fileInput.style.setProperty('z-index', hasFile ? '0' : '5', 'important');
      fileInput.style.setProperty('opacity', '0', 'important');
      fileInput.style.setProperty('position', 'absolute', 'important');
      fileInput.style.setProperty('inset', '0', 'important');
      fileInput.style.setProperty('width', '100%', 'important');
      fileInput.style.setProperty('height', '100%', 'important');
      fileInput.style.setProperty('cursor', hasFile ? 'default' : 'pointer', 'important');
    }
  }

  function getCustomerId() {
    const host = findHost();
    return host?.dataset?.customerId || '';
  }

  function getDraftStorageKey() {
    const customerId = getCustomerId();
    if (!customerId) return '';
    return `sg-sw-form-draft:${customerId}`;
  }

  // Attachments live in IndexedDB rather than alongside the rest of the draft:
  // localStorage only holds strings, so a file would have to be base64'd into a
  // ~5MB budget, and this field accepts up to 10MB.
  const DRAFT_FILE_DB = 'sg-sw-form-drafts';
  const DRAFT_FILE_STORE = 'files';

  function withDraftFileStore(mode, run) {
    return new Promise((resolve, reject) => {
      if (!window.indexedDB) {
        reject(new Error('IndexedDB unavailable'));
        return;
      }

      const open = window.indexedDB.open(DRAFT_FILE_DB, 1);
      open.onupgradeneeded = () => {
        if (!open.result.objectStoreNames.contains(DRAFT_FILE_STORE)) {
          open.result.createObjectStore(DRAFT_FILE_STORE);
        }
      };
      open.onerror = () => reject(open.error);
      open.onsuccess = () => {
        const db = open.result;
        let request;
        try {
          const tx = db.transaction(DRAFT_FILE_STORE, mode);
          request = run(tx.objectStore(DRAFT_FILE_STORE));
          tx.oncomplete = () => {
            db.close();
            resolve(request?.result);
          };
          tx.onabort = () => {
            db.close();
            reject(tx.error);
          };
          tx.onerror = () => {
            db.close();
            reject(tx.error);
          };
        } catch (error) {
          db.close();
          reject(error);
        }
      };
    });
  }

  function saveDraftFiles(key, filesByField) {
    if (!Object.keys(filesByField).length) return deleteDraftFiles(key);
    return withDraftFileStore('readwrite', (store) => store.put(filesByField, key));
  }

  function loadDraftFiles(key) {
    return withDraftFileStore('readonly', (store) => store.get(key));
  }

  function deleteDraftFiles(key) {
    return withDraftFileStore('readwrite', (store) => store.delete(key));
  }

  function collectDraftFiles(form) {
    const files = {};
    form.querySelectorAll('input[type="file"]').forEach((input) => {
      const key = input.id || input.name || '';
      const file = input.files?.[0];
      if (key && file) files[key] = file;
    });
    return files;
  }

  function findDraftFileInput(form, key) {
    return (
      form.querySelector(`input[type="file"]#${CSS.escape(key)}`) ||
      form.querySelector(`input[type="file"][name="${CSS.escape(key)}"]`) ||
      form.querySelector('input[type="file"]')
    );
  }

  // A file input's value can't be assigned from a path, so the stored bytes are
  // rebuilt into a File and handed over through a DataTransfer.
  function applyFileToInput(input, blob, name) {
    if (!input || !blob) return false;

    try {
      const fileName = name || blob.name || 'attachment';
      const file =
        blob instanceof File && blob.name === fileName
          ? blob
          : new File([blob], fileName, { type: blob.type || 'application/octet-stream' });
      const transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return input.files.length > 0;
    } catch (_) {
      return false;
    }
  }

  function restoreDraftFiles(form, data, statusEl) {
    const key = getDraftStorageKey();
    const meta = data?.files || {};
    if (!key || !Object.keys(meta).length) return;

    loadDraftFiles(key)
      .then((stored) => {
        if (!stored) return;

        const restored = Object.entries(stored).filter(([fieldKey, blob]) =>
          applyFileToInput(findDraftFileInput(form, fieldKey), blob, meta[fieldKey]?.name)
        );

        if (restored.length && statusEl) {
          statusEl.textContent = 'Draft restored, including your attached file.';
        }
      })
      .catch(() => {
        if (statusEl) {
          statusEl.textContent = 'Draft restored, but your file needs to be attached again.';
        }
      });
  }

  function setElementValue(el, value) {
    if (!el) return;

    if (el.tagName === 'TEXTAREA') {
      const proto = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value');
      proto?.set?.call(el, value);
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (el.tagName === 'SELECT') {
      el.value = value;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    setInputValue(el, value);
  }

  function collectFormDraft(form) {
    const data = {
      fields: {},
      checkboxes: {},
      radios: {},
      dates: {},
      requestType: '',
      savedAt: Date.now(),
    };

    form.querySelectorAll('input, textarea, select').forEach((el) => {
      if (el.type === 'file') return;

      const key = el.id || el.name || el.getAttribute('data-testid') || '';
      if (!key) return;
      if (key === 'sg-sw-state-select') return;

      if (el.type === 'checkbox') {
        data.checkboxes[key] = el.checked;
        return;
      }

      if (el.type === 'radio') {
        if (el.checked) data.radios[el.name || key] = el.value;
        return;
      }

      data.fields[key] = el.value;
    });

    const stateSelect = form.querySelector('.sg-sw-state-select');
    if (stateSelect) {
      data.fields['custom#state'] = stateSelect.value;
    }

    form.querySelectorAll('[data-testid="date-birthday"]').forEach((group) => {
      const label = (group.querySelector('[class*="birthdayText"]')?.textContent || '').trim();
      const native = group.querySelector('.sg-sw-native-date');
      if (label && native?.value) {
        data.dates[label] = native.value;
      }
    });

    const requestValue = form.querySelector('#custom\\#request_type-selector-value');
    if (requestValue) {
      data.requestType = (requestValue.textContent || '').trim();
    }

    return data;
  }

  function restoreRequestType(form, value) {
    if (!value) return;
    const toggle = form.querySelector('[aria-labelledby*="request_type-selector-label"]');
    const valueEl = form.querySelector('#custom\\#request_type-selector-value');
    if (!toggle) return;

    const current = (valueEl?.textContent || '').trim();
    if (current === value) return;

    toggle.click();
    window.setTimeout(() => {
      const options = [
        ...form.querySelectorAll('[role="option"], [class*="optionListItem"] [tabindex], [class*="optionListItem"] div'),
      ];
      const match = options.find((opt) => (opt.textContent || '').trim() === value);
      if (match) {
        match.click();
      } else {
        toggle.click();
      }
    }, 50);
  }

  function restoreFormDraft(form, data) {
    if (!form || !data) return;

    Object.entries(data.fields || {}).forEach(([key, value]) => {
      if (value == null || value === '') return;

      let el =
        form.querySelector(`#${CSS.escape(key)}`) ||
        form.querySelector(`[name="${CSS.escape(key)}"]`) ||
        form.querySelector(`[data-testid="field-${CSS.escape(key)}"]`);

      if (key === 'custom#state') {
        const stateSelect = form.querySelector('.sg-sw-state-select');
        if (stateSelect) {
          stateSelect.value = value;
          stateSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        el = form.querySelector('[data-testid="field-custom#state"]');
      }

      if (!el || el.type === 'file' || el.type === 'checkbox' || el.type === 'radio') return;
      setElementValue(el, value);
    });

    Object.entries(data.checkboxes || {}).forEach(([key, checked]) => {
      const el = form.querySelector(`#${CSS.escape(key)}`) || form.querySelector(`[name="${CSS.escape(key)}"]`);
      if (!el || el.type !== 'checkbox') return;
      if (Boolean(el.checked) !== Boolean(checked)) {
        el.click();
      }
    });

    Object.entries(data.radios || {}).forEach(([name, value]) => {
      const el =
        form.querySelector(`input[type="radio"][name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`) ||
        form.querySelector(`#${CSS.escape(`${name}-${value}`)}`);
      if (el && !el.checked) el.click();
    });

    Object.entries(data.dates || {}).forEach(([label, value]) => {
      form.querySelectorAll('[data-testid="date-birthday"]').forEach((group) => {
        const groupLabel = (group.querySelector('[class*="birthdayText"]')?.textContent || '').trim();
        if (groupLabel !== label) return;
        const native = group.querySelector('.sg-sw-native-date');
        if (!native) return;
        setElementValue(native, value);
        native.dispatchEvent(new Event('input', { bubbles: true }));
        native.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    if (data.requestType) {
      restoreRequestType(form, data.requestType);
    }

    const host = findHost();
    if (host) syncFormFieldsBeforeSubmit(host);
  }

  function clearFormDraft() {
    const key = getDraftStorageKey();
    if (!key) return;
    try {
      localStorage.removeItem(key);
    } catch (_) {
      /* ignore */
    }
    deleteDraftFiles(key).catch(() => {});
  }

  function saveFormDraft(form, statusEl) {
    const key = getDraftStorageKey();
    if (!key || !form) return false;

    syncFormFieldsBeforeSubmit(findHost() || form);
    const data = collectFormDraft(form);
    const files = collectDraftFiles(form);
    data.files = Object.fromEntries(
      Object.entries(files).map(([fieldKey, file]) => [
        fieldKey,
        { name: file.name, size: file.size, type: file.type },
      ])
    );

    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (_) {
      if (statusEl) statusEl.textContent = 'Unable to save draft in this browser.';
      return false;
    }

    const fileCount = Object.keys(files).length;
    if (statusEl) {
      statusEl.textContent = 'Draft saved. You can leave and finish later.';
    }

    saveDraftFiles(key, files)
      .then(() => {
        if (fileCount && statusEl) {
          statusEl.textContent = 'Draft saved, including your file. You can leave and finish later.';
        }
      })
      .catch(() => {
        if (fileCount && statusEl) {
          statusEl.textContent = 'Draft saved, but your file was too large to keep. Reattach it before submitting.';
        }
      });

    return true;
  }

  function loadSavedDraft(form, statusEl) {
    const key = getDraftStorageKey();
    if (!key || !form || form.dataset.sgDraftRestored === 'true') return;

    let raw = '';
    try {
      raw = localStorage.getItem(key) || '';
    } catch (_) {
      return;
    }
    if (!raw) {
      form.dataset.sgDraftRestored = 'true';
      return;
    }

    let data;
    try {
      data = JSON.parse(raw);
    } catch (_) {
      form.dataset.sgDraftRestored = 'true';
      return;
    }

    restoreFormDraft(form, data);
    form.dataset.sgDraftRestored = 'true';
    if (statusEl) {
      statusEl.textContent = 'Draft restored.';
    }
    restoreDraftFiles(form, data, statusEl);
  }

  function upgradeDraftControls(root) {
    if (!getCustomerId()) return;

    walkShadowRoots(root, (node) => {
      const form = node.querySelector?.('[data-testid="form"]');
      if (!form) return;

      const submitBtn =
        form.querySelector('button[type="submit"]') || form.querySelector('[data-testid="btn-form-submit"]');
      if (!submitBtn) return;

      let actions = form.querySelector('.sg-sw-actions');
      if (!actions) {
        actions = document.createElement('div');
        actions.className = 'sg-sw-actions';
        submitBtn.parentNode?.insertBefore(actions, submitBtn);
        actions.appendChild(submitBtn);
      } else if (!actions.contains(submitBtn)) {
        actions.appendChild(submitBtn);
      }

      let draftBtn = actions.querySelector('.sg-sw-draft-btn');
      if (!draftBtn) {
        draftBtn = document.createElement('button');
        draftBtn.type = 'button';
        draftBtn.className = 'sg-sw-draft-btn';
        draftBtn.textContent = 'Save Draft';
        actions.insertBefore(draftBtn, submitBtn);
      }

      let statusEl = actions.querySelector('.sg-sw-draft-status');
      if (!statusEl) {
        statusEl = document.createElement('p');
        statusEl.className = 'sg-sw-draft-status';
        statusEl.setAttribute('aria-live', 'polite');
        actions.appendChild(statusEl);
      }

      if (!draftBtn.dataset.sgDraftBound) {
        draftBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          saveFormDraft(form, statusEl);
        });
        draftBtn.dataset.sgDraftBound = 'true';
      }

      loadSavedDraft(form, statusEl);
    });
  }

  function upgradeFileInputs(root) {
    walkShadowRoots(root, (node) => {
      node.querySelectorAll?.('[class*="formFileInput_"]:not([class*="formFileInputField"]):not([class*="formFileInputButton"])').forEach((container) => {
        const btn = container.querySelector('[class*="formFileInputField"]');
        const addBtn = container.querySelector('[class*="formFileInputButton"]');
        const fileInput = container.querySelector('input[type="file"]');
        if (!btn || !addBtn || !fileInput) return;

        container.querySelectorAll('.sg-sw-file-help').forEach((el, index) => {
          if (index > 0) el.remove();
        });
        btn.querySelectorAll('.sg-sw-file-status').forEach((el, index) => {
          if (index > 0) el.remove();
        });

        let status = btn.querySelector('.sg-sw-file-status');
        if (!status) {
          status = document.createElement('p');
          status.className = 'sg-sw-file-status';
          status.textContent = 'No file chosen';
          btn.appendChild(status);
        }

        btn.dataset.sgFileState = btn.dataset.sgFileState || 'empty';

        let statusUpdating = false;

        const updateStatus = () => {
          if (statusUpdating) return;
          statusUpdating = true;

          try {
            const liveInput = container.querySelector('input[type="file"]') || fileInput;
            const liveAddBtn = container.querySelector('[class*="formFileInputButton"]') || addBtn;
            const liveStatus = btn.querySelector('.sg-sw-file-status') || status;
            const file = liveInput.files?.[0];

            if (file) {
              btn.dataset.sgLastFileName = file.name;
            } else if (!fileRowHasFile(btn, liveInput)) {
              delete btn.dataset.sgLastFileName;
            }

            syncFileUploadedLayout(btn, liveAddBtn, liveStatus, liveInput);
          } finally {
            statusUpdating = false;
          }
        };

        updateStatus();

        // Re-bind whenever Shopify replaces the native input node.
        if (fileInput.dataset.sgFileBound !== 'true') {
          fileInput.addEventListener('change', updateStatus);
          fileInput.dataset.sgFileBound = 'true';
        }

        if (!container.dataset.sgFileChangeDelegated) {
          container.addEventListener(
            'change',
            (event) => {
              if (event.target?.matches?.('input[type="file"]')) {
                updateStatus();
              }
            },
            true
          );
          container.dataset.sgFileChangeDelegated = 'true';
        }

        if (!container.dataset.sgFileClearDelegated) {
          container.addEventListener(
            'click',
            (event) => {
              const target = event.target;
              if (
                !target?.closest?.('[class*="formFileInputCancel"]') &&
                !target?.closest?.('[class*="formFileInputRemove"]')
              ) {
                return;
              }
              // Shopify tears the uploaded row down asynchronously, so re-check
              // a few times instead of trusting the state at click time.
              [0, 60, 200, 500, 1000].forEach((delay) => window.setTimeout(updateStatus, delay));
            },
            true
          );
          container.dataset.sgFileClearDelegated = 'true';
        }

        // Shopify re-renders this row after our sync has run (upload progress,
        // validation), which can strip out the filename we injected. Put it back
        // rather than leaving the placeholder label showing.
        if (!btn.dataset.sgFileRepairObserved) {
          let repairQueued = false;
          const repairObserver = new MutationObserver(() => {
            if (repairQueued) return;
            repairQueued = true;
            window.requestAnimationFrame(() => {
              repairQueued = false;
              const liveInput = container.querySelector('input[type="file"]') || fileInput;
              if (!fileRowHasFile(btn, liveInput)) return;
              const shown = btn.querySelector('.sg-sw-file-name');
              if (shown?.isConnected) return;
              updateStatus();
            });
          });
          repairObserver.observe(btn, { childList: true, subtree: true });
          btn.dataset.sgFileRepairObserved = 'true';
        }

        container.querySelectorAll('.sg-sw-file-help').forEach((help) => {
          help.textContent = FILE_HELP_TEXT;
        });

        container.querySelectorAll('p').forEach((p) => {
          if (/download link|notification email/i.test(p.textContent || '')) {
            p.textContent = FILE_HELP_TEXT;
            p.classList.add('sg-sw-file-help');
          }
        });

        if (!container.querySelector('.sg-sw-file-help')) {
          const help = document.createElement('p');
          help.className = 'sg-sw-file-help';
          help.textContent = FILE_HELP_TEXT;
          container.appendChild(help);
        }

        btn.style.display = 'flex';
        btn.style.alignItems = 'center';
        btn.style.gap = '0.75rem';
        btn.style.borderRadius = '0';
        btn.style.width = '100%';
        btn.style.position = 'relative';
        btn.style.overflow = 'visible';

        const liveInput = container.querySelector('input[type="file"]') || fileInput;
        const fileLabel = container.querySelector('[class*="formFileInputLabel"]') || liveInput.closest('label');
        const hasFile = btn.dataset.sgFileState === 'uploaded';

        if (fileLabel) {
          fileLabel.style.setProperty('position', 'absolute', 'important');
          fileLabel.style.setProperty('inset', '0', 'important');
          fileLabel.style.setProperty('width', '100%', 'important');
          fileLabel.style.setProperty('height', '100%', 'important');
          fileLabel.style.setProperty('margin', '0', 'important');
          fileLabel.style.setProperty('padding', '0', 'important');
          fileLabel.style.setProperty('z-index', hasFile ? '0' : '5', 'important');
          fileLabel.style.setProperty('cursor', 'pointer', 'important');
          fileLabel.style.setProperty('pointer-events', hasFile ? 'none' : 'auto', 'important');
          fileLabel.style.setProperty('display', 'block', 'important');
        }

        liveInput.style.setProperty('position', 'absolute', 'important');
        liveInput.style.setProperty('inset', '0', 'important');
        liveInput.style.setProperty('width', '100%', 'important');
        liveInput.style.setProperty('height', '100%', 'important');
        liveInput.style.setProperty('opacity', '0', 'important');
        liveInput.style.setProperty('cursor', hasFile ? 'default' : 'pointer', 'important');
        liveInput.style.setProperty('font-size', '0', 'important');
        liveInput.style.setProperty('z-index', hasFile ? '0' : '5', 'important');
        liveInput.style.setProperty('margin', '0', 'important');
        liveInput.style.setProperty('padding', '0', 'important');
        liveInput.style.setProperty('pointer-events', hasFile ? 'none' : 'auto', 'important');

        const content = btn.querySelector('[class*="formFileInputContent"]');
        if (content && !hasFile) {
          content.style.flex = '0 0 auto';
          content.style.width = 'auto';
          content.style.height = 'auto';
          content.style.minHeight = '0';
          content.style.pointerEvents = 'none';
        }

        if (!btn.dataset.sgFileClickBound) {
          btn.addEventListener('click', (event) => {
            const target = event.target;
            if (
              target?.closest?.('.sg-sw-file-remove') ||
              target?.closest?.('[class*="formFileInputRemove"]') ||
              target?.closest?.('[class*="formFileInputCancel"]')
            ) {
              return;
            }
            if (btn.dataset.sgFileState === 'uploaded') return;

            const input = container.querySelector('input[type="file"]');
            if (!input) return;

            // Never block native label/input activation.
            if (
              target === input ||
              target?.closest?.('input[type="file"]') ||
              target?.closest?.('label') ||
              target?.closest?.('[class*="formFileInputLabel"]')
            ) {
              return;
            }

            // Fallback for clicks on non-interactive chrome (status text, padding).
            input.click();
          });
          btn.dataset.sgFileClickBound = 'true';
        }

        syncFileUploadedLayout(
          btn,
          container.querySelector('[class*="formFileInputButton"]') || addBtn,
          btn.querySelector('.sg-sw-file-status') || status,
          liveInput
        );
        container.dataset.sgFileUpgraded = 'true';
      });
    });
  }

  function fixSectionTitles(root) {
    walkShadowRoots(root, (node) => {
      node.querySelectorAll?.('[class*="birthdayText"]').forEach((el) => {
        const text = (el.textContent || '').trim();
        if (text === 'DATE SENT') {
          el.textContent = 'Date Sent';
        }
      });

      node.querySelectorAll?.('[class*="selectContainer"] p[class*="_label_"]').forEach((el) => {
        const text = (el.textContent || '').trim();
        if (text === 'REQUEST TYPE') {
          el.textContent = 'Request Type';
        }
      });

      node.querySelectorAll?.('legend[class*="checkboxLegend"]').forEach((el) => {
        const text = (el.textContent || '').trim();
        if (/^chuck type:?$/i.test(text)) {
          el.textContent = 'Chuck Type:';
        }
      });

      node.querySelectorAll?.('[class*="formFileInput"] p[class*="textBody"], [class*="formFileInput"] > p').forEach((el) => {
        const text = (el.textContent || '').trim();
        if (/^picture of failure$/i.test(text)) {
          el.textContent = 'Picture of Failure';
          el.style.fontWeight = '700';
        }
      });
    });
  }

  function applyFieldLayout(root) {
    walkShadowRoots(root, (node) => {
      const form = node.querySelector?.('[data-testid="form"]') || (node.matches?.('[data-testid="form"]') ? node : null);
      if (!form) return;

      form.style.display = 'grid';
      form.style.gridTemplateColumns = 'minmax(0, 1fr)';
      form.style.gap = '0';
      form.style.width = '100%';
      form.style.maxWidth = '100%';
      form.style.margin = '0';
      form.style.padding = '0';
      form.style.boxSizing = 'border-box';
      form.style.overflow = 'visible';

      node.querySelectorAll?.('[class*="formContainer"], [class*="inline"], [class*="gridItem"]').forEach((el) => {
        el.style.width = '100%';
        el.style.maxWidth = '100%';
        el.style.overflow = 'visible';
        el.style.paddingLeft = '0';
        el.style.paddingRight = '0';
        el.style.boxSizing = 'border-box';
      });

      form.querySelectorAll(':scope > *').forEach((child) => {
        child.style.gridColumn = '1 / -1';

        if (child.querySelector?.('shop-lead-capture') && !child.querySelector?.('[class*="formFieldContainer"]')) {
          child.style.marginBottom = '0';
          return;
        }

        child.style.marginBottom = '20px';
      });
    });
  }

  function forceWhiteText(el) {
    if (!el) return;
    el.style.setProperty('color', '#ffffff', 'important');
    el.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important');
    el.style.textShadow = 'none';
  }

  function styleSectionHeading(el) {
    const text = (el.textContent || '').trim().toLowerCase();
    if (!text) return;

    if (
      text === 'part information' ||
      text === 'sales dept. info' ||
      text.includes('warranty return') ||
      text.includes('warranty policy')
    ) {
      forceWhiteText(el);
      el.style.fontSize = '0.95rem';
      el.style.fontWeight = '700';
      el.style.letterSpacing = '0.06em';
      el.style.textTransform = 'uppercase';
      el.style.margin = '1.5rem 0 1rem';
      el.style.gridColumn = '1 / -1';
    }
  }

  function applyInlineOverrides(root) {
    walkShadowRoots(root, (node) => {
      node.querySelectorAll?.('h1, h2, h3, h4, p, span').forEach((el) => {
        styleSectionHeading(el);
      });

      node
        .querySelectorAll?.(
          '[class*="formInputFieldLabel"], label[id^="label-"], [class*="birthdayText"], p[class*="_label_"], legend[class*="checkboxLegend"], [class*="checkboxLegend"]'
        )
        .forEach((label) => {
          forceWhiteText(label);
          label.style.position = 'static';
          label.style.transform = 'none';
          label.style.top = 'auto';
          label.style.left = 'auto';
          label.style.background = 'transparent';
          label.style.backgroundColor = 'transparent';
          label.style.boxShadow = 'none';
          label.style.border = 'none';
          label.style.minHeight = '0';
          label.style.height = 'auto';
          label.style.padding = '0';
          label.style.width = 'auto';
          label.style.zIndex = 'auto';
        });

      node
        .querySelectorAll?.(
          '[class*="formFileInput"] p[class*="textBody"], [class*="formFileInput"] > p:not([class*="formFileInputButton"]):not(.sg-sw-file-status):not(.sg-sw-file-help)'
        )
        .forEach((label) => {
          forceWhiteText(label);
        });

      node.querySelectorAll?.('[class*="selectContainer"]:has(p[class*="_label_"])').forEach((container) => {
        container.style.display = 'flex';
        container.style.flexDirection = 'column';
        container.style.alignItems = 'stretch';
        container.style.width = '100%';
        container.style.marginBottom = '20px';
      });

      node.querySelectorAll?.('[class*="selectToggle"]').forEach((btn) => {
        btn.style.backgroundColor = 'rgba(255, 255, 255, 0.08)';
        btn.style.border = '1px solid rgba(255, 255, 255, 0.45)';
        btn.style.boxShadow = 'none';
        btn.style.color = '#ffffff';
        btn.style.outline = 'none';
        btn.style.borderRadius = '4px';

        btn.querySelectorAll('[class*="selectToggleText"], [class*="arrowDownIcon"]').forEach((el) => {
          el.style.background = 'transparent';
          el.style.backgroundColor = 'transparent';
          el.style.border = 'none';
          el.style.boxShadow = 'none';
          el.style.outline = 'none';
          el.style.width = 'auto';
          el.style.minHeight = '0';
          el.style.padding = '0';
          el.style.margin = '0';
        });
      });

      node.querySelectorAll?.('[class*="selectContainer"]:has(p[class*="_label_"]) [class*="selectToggle"]').forEach((btn) => {
        btn.style.width = '100%';
        btn.style.justifyContent = 'space-between';
      });

      node.querySelectorAll?.('[class*="dropdownContainer"], #country-selector-dropdown, [class*="optionList"]').forEach((el) => {
        el.style.backgroundColor = '#1a6421';
        el.style.color = '#ffffff';
      });

      node.querySelectorAll?.('[class*="optionListItem"] [role="option"], [class*="optionListItem"] div[tabindex]').forEach((el) => {
        el.style.color = '#ffffff';
      });

      node.querySelectorAll?.('[class*="arrowDownIcon"] svg path').forEach((path) => {
        path.setAttribute('fill', '#ffffff');
      });

      node.querySelectorAll?.('[class*="formFileInput"] button, [class*="formFileInput"] [role="button"]').forEach((btn) => {
        if (btn.matches('[class*="formFileInputButton"]') || btn.matches('[class*="formFileInputField"]')) return;

        const label = `${btn.getAttribute('aria-label') || ''} ${btn.textContent || ''}`.toLowerCase();
        const isRemove =
          Boolean(btn.querySelector('svg')) ||
          label.includes('remove') ||
          label.includes('clear') ||
          label.includes('delete') ||
          label.trim() === 'x' ||
          label.trim() === '×';

        if (!isRemove) return;

        styleRemoveButton(btn);
      });

      node.querySelectorAll?.('button[type="submit"], [data-testid="btn-form-submit"]').forEach((btn) => {
        styleSubmitButton(btn);
      });
    });
  }

  function applySpeedgripTheme(root) {
    if (applyingTheme) return;
    applyingTheme = true;

    try {
      bindSuccessStepObserver();

      if (isPageInSuccessState(root)) {
        injectShadowStyles(root);
        customizeSuccessState(root);
        hideServiceWarrantyPageChrome();
        return;
      }

      centerFormEmbed(root);
      injectShadowStyles(root);
      upgradeDatePickers(root);
      upgradeStateField(root);
      upgradePoField(root);
      upgradeFileInputs(root);
      fixFieldLabels(root);
      fixSectionTitles(root);
      hideDuplicateFormChrome(root);
      applyFieldLayout(root);
      bindSubmitHandling(root);
      customizeSuccessState(root);
      applyInlineOverrides(root);
      upgradeDraftControls(root);
    } finally {
      applyingTheme = false;
    }
  }

  let applyingTheme = false;
  let themeApplied = false;

  function findHost() {
    return (
      document.querySelector('.service-warranty-page__shopify-form') ||
      document.querySelector('[id*="service_warranty_shopify_form"]') ||
      document.querySelector('[data-form-root="true"]')?.closest('.shopify-section')
    );
  }

  function init() {
    const host = findHost();
    if (!host) {
      const waitForHost = new MutationObserver(() => {
        if (findHost()) {
          waitForHost.disconnect();
          init();
        }
      });
      waitForHost.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(() => waitForHost.disconnect(), 30000);
      return;
    }

    const runOnce = () => {
      if (themeApplied) return;
      const embed = host.querySelector('shopify-forms-embed');
      // Wait until the Shopify form has mounted into the shadow tree.
      if (!embed?.shadowRoot?.querySelector?.('[data-testid="form"], form, input')) {
        return false;
      }
      applySpeedgripTheme(host);
      themeApplied = true;
      return true;
    };

    if (runOnce()) return;

    const bootObserver = new MutationObserver(() => {
      if (runOnce()) bootObserver.disconnect();
    });
    bootObserver.observe(host, { childList: true, subtree: true });
    window.setTimeout(() => {
      bootObserver.disconnect();
      if (!themeApplied) applySpeedgripTheme(host);
      themeApplied = true;
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
